import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=187cbfc7&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=ts&"
export * from "./editor.vue?vue&type=script&lang=ts&"
import style0 from "./editor.vue?vue&type=style&index=0&id=187cbfc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cbfc7",
  null
  
)

export default component.exports